import { render, staticRenderFns } from "./MergeMemberBankAccountForm.vue?vue&type=template&id=f0ffd86e&"
import script from "./MergeMemberBankAccountForm.vue?vue&type=script&lang=js&"
export * from "./MergeMemberBankAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports